import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA, MatLegacySnackBarRef as MatSnackBarRef } from '@angular/material/legacy-snack-bar';

@Component({
    selector: 'app-snackbar-error',
    template: `
        <div
        data-testid="popup:error-message">
            <mat-icon>error</mat-icon>

            <span>{{ data.message }}</span>
        </div>

        <div class="mat-simple-snackbar-action" *ngIf="hasAction">
            <button cll-button (click)="action()">{{ data.action }}</button>
        </div>
    `,
    styleUrls: ['./app-error-snackbar.component.scss'],
})
export class AppErrorSnackbarComponent {
    constructor(
        public snackBarRef: MatSnackBarRef<AppErrorSnackbarComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public readonly data: { message: string; action: string }) {
    }

    /** Performs the action on the snack bar. */
    action(): void {
        this.snackBarRef.dismissWithAction();
    }

    /** If the action button should be shown. */
    get hasAction(): boolean {
        return !!this.data.action;
    }
}
